export enum POSHTA_MARKER_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum POSHTA_MARKER_SOURCE {
  CLAN_MISSIONS = 'clan_missions',
  CLAN_REQUESTS = 'clan_requests',
  DIVISION_STAR = 'division_star',
}

export enum POSHTA_MARKER_NAME {
  REWARD_AVAILABLE = 'reward_available',
  NEW_APPLICATION = 'new_application',
}

export interface PoshtaMarker {
  id: string; // UUIDv4
  name: POSHTA_MARKER_NAME;
  source: POSHTA_MARKER_SOURCE;
  status: POSHTA_MARKER_STATUS;
  tags: string[];
}
